export const MANAGER_HEADER_HEIGHT = 40
export const MANAGER_SIDEBAR_DRAWER_WIDTH = 240
export const MANAGER_SIDEBAR_DRAWER_WIDTH_CLOSED = 46
export const MANAGER_HEADER_COLOR = 'rgb(71,158,159)'